
import { useState } from 'react';
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import AboutSection from '../../components/feature/AboutSection';
import KisaraSection from '../../components/feature/KisaraSection';
import MissionSection from '../../components/feature/MissionSection';
import ServicesSection from '../../components/feature/ServicesSection';
import WhyChooseSection from '../../components/feature/WhyChooseSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [language, setLanguage] = useState<'es' | 'en'>('es');

  const handleLanguageChange = (lang: 'es' | 'en') => {
    setLanguage(lang);
  };

  return (
    <div className="min-h-screen">
      <Header language={language} onLanguageChange={handleLanguageChange} />
      <HeroSection language={language} />
      <AboutSection language={language} />
      <KisaraSection language={language} />
      <MissionSection language={language} />
      <ServicesSection language={language} />
      <WhyChooseSection language={language} />
      <TestimonialsSection language={language} />
      <FAQSection language={language} />
      <ContactSection language={language} />
      <Footer language={language} />
    </div>
  );
}
